import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import styles from './material-tab-item.module.css';

interface MaterialTabItemProps {
  index: number | string;
  materialDescription: string | number;
  materialCode: string | number;
  unit: string | number;
  qty: string | number;
  remarks: string;
  previousRate: string | number;
}

const MaterialTabItem: React.FC<MaterialTabItemProps> = ({
  materialDescription,
  materialCode,
  qty,
  remarks,
  previousRate,
  unit,
  index,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.caption}>Material No.{index}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.description}>
          <span>Material Code</span>
          <span>{materialCode || EMPTY_FIELD_PLACEHOLDER}</span>
        </div>
        <div className={styles.description}>
          <span>Material Description</span>
          <span>{materialDescription || EMPTY_FIELD_PLACEHOLDER}</span>
        </div>
        <div className={styles.description}>
          <span>Unit</span>
          <span>{unit || EMPTY_FIELD_PLACEHOLDER}</span>
        </div>
        <div className={styles.description}>
          <span>Required Qty.</span>
          <span>{qty || EMPTY_FIELD_PLACEHOLDER}</span>
        </div>
        <div className={styles.description}>
          <span>Previous Rate</span>
          <span>{previousRate || EMPTY_FIELD_PLACEHOLDER}</span>
        </div>
        <div className={styles.description}>
          <span>Remarks</span>
          <span>{remarks || EMPTY_FIELD_PLACEHOLDER}</span>
        </div>
      </div>
    </div>
  );
};

export default MaterialTabItem;
